import RentalContactContainer from "./RentalContactContainer";

export default RentalContactContainer;
